export default __webpack_public_path__ + "static/media/TeleConsultation.8fce73d0.svg";